import { useSyncExternalStore } from 'react';
import { createLocalDayClock } from '../lib/localDayClock';

const clock = createLocalDayClock();

export function useLocalDay(): number {
  return useSyncExternalStore(clock.subscribe, clock.getSnapshot);
}
